const getParentCategoryIds = ({ categories, targetId }) => {
    if (!categories || !Array.isArray(categories)) {
        return null;
    }

    const findCategory = id => categories.find(cat => cat.id === id);
    const targetCategory = findCategory(targetId);

    if (!targetCategory) {
        return null;
    }

    const result = [];
    let currentId = targetId;

    while (currentId) {
        result.unshift(currentId);

        const category = findCategory(currentId);

        if (!category || !category.parentId) {
            break;
        }

        currentId = category.parentId;
    }

    return result;
};

export default getParentCategoryIds;
